import React from 'react';
import { SUPPORT_EMAIL } from './constants';
export function Footer() {
  return <footer className="bg-brand-light px-4 py-3 text-center" data-id="element-66" data-mp="3gezdb400vr15">
      <div className="mx-auto max-w-3xl space-y-1" data-id="element-67" data-mp="3ggk88uq91bzj">
        <p className="text-[11px] font-semibold text-brand-navy sm:text-xs" data-id="element-68" data-mp="32oni2w855c5s">
          © 2026 VOLLEYBALL COACH PRO™ — All Rights Reserved.
        </p>
        <p className="text-[11px] font-medium leading-snug text-brand-muted sm:text-xs" data-id="element-69" data-mp="36nd57gize82m">
          This system is provided for educational and professional development purposes. Coaches
          remain responsible for adapting drills, training loads, activities, and practice structures
          to the age, experience, physical condition, environment, and needs of their players, and
          for following applicable organizational and safety requirements.
        </p>
        <p className="text-[11px] font-medium text-brand-muted sm:text-xs" data-id="element-70" data-mp="29yds9o7gci43">
          Terms &amp; Conditions • Privacy Policy • Contact
        </p>
        <p className="text-[11px] font-medium text-brand-muted sm:text-xs" data-id="element-71" data-mp="3l9k7bh9idvfe">
          Support:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-brand-blue hover:underline" data-id="element-72" data-mp="3gah29wtj3p7f">
            {SUPPORT_EMAIL}
          </a>
        </p>
      </div>
    </footer>;
}